import React from 'react';
import {
  ViewButton,
  EditButton,
  LinkButton,
} from '../Common/DataTable/tableActionButtons';
import { getFilter, getSort } from '../Common/DataTable/tableHelpers';
import moment from 'moment';

const createTableColumns = (
  openViewModal,
  openEditModal,
  user,
  openLinkGeneratorModal,
) => [
  {
    title: 'ID',
    name: 'id',
    hidden: true,
  },
  {
    title: 'Nome',
    name: 'name',
    width: 180,
    sort: true,
  },
  {
    title: 'Codice',
    name: 'code',
    width: 120,
    sort: true,
  },
  {
    title: 'Commissione Mensile',
    name: 'monthlyCommission',
    width: 150,
    formatterComponent: ({ value }) => `€ ${value}`,
    sort: true,
  },
  {
    title: 'Commissione Semestrale',
    name: 'semiannualCommission',
    width: 170,
    formatterComponent: ({ value }) => `€ ${value}`,
    sort: true,
  },
  {
    title: 'Attivo',
    name: 'isActive',
    width: 100,
    formatterComponent: ({ value }) =>
      value ? (
        <span className="badge badge-success font-size-12">SI</span>
      ) : (
        <span className="badge badge-danger font-size-12">NO</span>
      ),
    filter: (value, filter) => getFilter(value ? 'si' : 'no', filter.value),
    sorting: (a, b) => getSort(a ? 'si' : 'no', b ? 'si' : 'no'),
  },
  {
    title: 'Creato il',
    name: 'createdAt',
    width: 140,
    formatterComponent: ({ value }) =>
      value ? moment(value).format('DD/MM/YYYY') : '',
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(`${moment(value).format('DD/MM/YYYY')}`, filter.value),
  },
  {
    title: 'Azioni',
    name: 'action',
    width: 160,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        {openViewModal && <ViewButton row={row} onPress={openViewModal} />}
        <EditButton row={row} onPress={openEditModal} />
        {openLinkGeneratorModal && (
          <LinkButton
            row={row}
            label="Genera Link"
            onPress={openLinkGeneratorModal}
          />
        )}
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
